import {config} from "../config";

export default class Helper {
    static addLeadingZero(number) {
        return number < 10 ? '0' + number : number.toString();
    }

    static getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }


    static getRealComicsPath(path: string): string {
        if (!path) return path;

        // якщо вже абсолютний URL — нічого не чіпаємо
        if (/^https?:\/\//i.test(path)) {
            return path;
        }

        const isCdnPath = path.includes("/cdn/");

        // прибираємо ./ і /
        const cleanPath = path
            .replace(/^\.\/?/, "")
            .replace(/^\/+/, "");

        //  1. Android + Nutaku + CDN → веб
        if (config.isAndroid && config.isNutaku && isCdnPath) {
            const base = config.cdnUrl.replace(/\/+$/, "");
            return `${base}/${cleanPath}`;
        }

        //  2. Android або Windows → локалка
        if (config.isAndroid || config.isWindows) {
            if (config.isWindows) {
                return `./${cleanPath}`; // ./img/...
            }

            if (config.isAndroid) {
                return cleanPath; // img/...
            }
        }

        //  3. Все інше → CDN
        const base = config.cdnUrl.replace(/\/+$/, "");
        return `${base}/${cleanPath}`;
    }
    static  getStepOrder = (step: string): number => {
        const match = step.match(/\d+$/); // цифри в кінці
        return match ? Number(match[0]) : 0;
    };
}

